// Helpers for the local PDF generator running as an AWS Lambda RIE in Docker.
// The dockerized container can't reach the editor on `localhost`, so the
// editor_url host is rewritten, and the response is the Lambda HTTP envelope
// (always 200 on axios, real status in `data.statusCode`, JSON string `body`).

import { downloadBlob } from './downloadBlob';

// Rewrite the editor origin so the container can reach it via Docker.
export const dockerEditorUrl = () =>
  window.location.origin.replace(/localhost|127\.0\.0\.1/, 'host.docker.internal');

// Parse the Lambda RIE envelope. For a downloaded PDF, trigger the browser
// download. For a preview, return `{ data: pages }` for the store consumer.
export const handleLocalPdfResponse = (response, type, name) => {
  const payload = JSON.parse(response.data.body);
  if (response.data.statusCode !== 200) {
    // `code` : erreur métier du service, lue par l'appelant (cf. pdfErrorMessage).
    throw Object.assign(new Error(payload.error || 'pdf gen failed'), {
      code: payload.code,
    });
  }
  if (type === 'preview') {
    return { data: payload.pages };
  }
  // PDF > 4 Mo (cap réponse Lambda locale) : le handler l'écrit sur le volume
  // monté au lieu de le renvoyer en base64 (cf. handler.js du repo pdf).
  if (payload.tooLargeForResponse) {
    return { tooLargeForResponse: true, localPath: payload.localPath };
  }
  const bytes = Uint8Array.from(atob(payload.pdf), (c) => c.charCodeAt(0));
  downloadBlob(new Blob([bytes], { type: 'application/pdf' }), `${name}.pdf`);
};
